<template>
  <div class="content-top-padding initiatives globalVisibility super" v-cloak>
    <InitNav gv />
    <GvNav redBg="second-nav-bg" secondNav="second-nav" />

    <div class="container-fluid banner p-0 mb-5">
      <img
        alt=""
        src="@/assets/initiatives/globalVisibility/superfans/banner_hksuperfans-e.jpg"
        class="d-none d-md-block"
      />
      <img
        alt=""
        src="@/assets/initiatives/globalVisibility/superfans/m_banner_hksuperfans-e.jpg"
        class="d-block d-md-none"
      />
    </div>

    <div class="container">
      <CustomBreadcrumb gv :lastTag="$t('title.gvSuperFans')" />
      <div class="row routing d-flex justify-content-between align-items-center mb-5">
        <div class="col main-theme">
          <router-link :to="{ name: 'HolidayAtHome' }" class="d-flex flex-row align-items-center">
            <div class="">
              <img class="mr-2 route-arrow" src="@/assets/01/btn_catalog_arrow_l.svg" />
            </div>
            <div>{{ $t("title.holiday") }}</div>
          </router-link>
        </div>
        <div class="col main-theme">
          <router-link
            :to="{ name: 'GearingUpTheTrade-Uncease' }"
            class="d-flex justify-content-end text-right align-items-center"
          >
            {{ $t("title.gearing") }}
            <img class="ml-2 route-arrow" src="@/assets/01/btn_catalog_arrow_r.svg" />
          </router-link>
        </div>
      </div>
      <GvIntro />
      <GvPageSelector />

      <div class="row page-header mb-5">
        <div class="col-12 main-theme text-center mb-4">
          <h3 v-if="$i18n.locale == 'zh'">
            Hong Kong Super Fans：口碑力挺　宣揚香港旅遊魅力
          </h3>
          <h3 v-else>
            Hong Kong Super Fans: Powerful Testimony
          </h3>
        </div>
        <div class="col-12 text-theme" v-if="$i18n.locale == 'zh'">
          香港正密鑼緊鼓地以嶄新的旅遊資源，準備迎接旅客和消費者重臨，預計待國際旅遊恢復後，率先來港的會是那些一直熱愛香港、曾經來港遊覽，或與香港有聯繫的旅客。與此同時，在可見的未來，區內爭相吸引旅客的情況將日趨激烈，因此，能夠切中目標旅客心思的可靠見證和實實在在的口碑，對吸引旅客訪港有著重要作用。有見及此，旅發局推出全球參與計劃，邀請熱愛香港的人士成為「Hong
          Kong Super
          Fans」，借助他們的影響力和對香港由衷的熱愛，對外做好口碑，鼓勵世界各地的旅客在跨境旅遊恢復後盡早來港遊玩。
        </div>
        <div class="col-12 text-theme" v-else>
          While Hong Kong is geared up in welcoming back visitors and interested consumers with new
          tourism assets, it is expected that, when travel resumes, people who have an enduring love
          for Hong Kong, those who have previously visited the city and those who have a connection
          with Hong Kong are more likely to return first. On the other hand, under the intensifying
          regional competition for visitors in foreseeable future, reliable testimony that speaks to
          our target segments’ interests and genuine words of mouth would play an instrumental role
          in bringing back visitors to Hong Kong. Therefore, the HKTB rolled out a global engagement
          programme and invited friends and fans of Hong Kong to become “Hong Kong Super Fans”,
          leveraging on their influence and heartfelt passion to spread positive word-of-mouth
          endorsement and encourage visitors from markets worldwide to head to Hong Kong as soon as
          travel resumes.
        </div>
      </div>

      <div class="row left-carou Friends-and-Fans mb-5">
        <CoolLightBox
          :items="lightbox.firstRow"
          :index="lightbox.index1"
          @close="lightbox.index1 = null"
          :effect="'fade'"
        >
        </CoolLightBox>
        <div class="col-lg-6 mb-5 mb-lg-0">
          <b-carousel id="carousel-1" class="carou-slide">
            <b-carousel-slide>
              <template #img>
                <img
                  @click="lightbox.index1 = 0"
                  class="d-block img-fluid w-100"
                  src="@/assets/initiatives/globalVisibility/superfans/4-2-4-1-preview-SuperFans-KV-e.jpg"
                  alt="image slot"
                />
              </template>
            </b-carousel-slide>
          </b-carousel>
        </div>
        <div class="col-lg-6">
          <div class="main-theme mb-4" v-if="$i18n.locale == 'zh'">
            <h4>
              香港的「超級粉絲」
            </h4>
          </div>
          <div class="main-theme mb-4" v-else>
            <h4>
              Friends and Fans of Hong Kong
            </h4>
          </div>
          <div class="text-theme" v-if="$i18n.locale == 'zh'">
            在「Hong Kong Super
            Fans」之中不乏居港外籍人士，亦包括在超過16個主要客源市場中，於社會及網絡上具有影響力的公眾人士。這班超級粉絲正是旅發局推動旅業復甦的重要組成部分，他們會擔當香港宣傳大使的角色，向各自所屬市場講述自己在香港旅遊中的親身經歷。
          </div>
          <div class="text-theme" v-else>
            “Hong Kong Super Fans” include expatriates living in Hong Kong as well as public figures
            of social and online influence in 16 key source markets. The Super Fans is an important
            and integral element of the HKTB’s tourism recovery plan as they will be the ambassadors
            who speak to their respective markets with their genuine and first-hand experience.
          </div>
        </div>
      </div>

      <div class="row right-carou Try-and-Tell mb-5">
        <CoolLightBox
          :items="lightbox.secondRowZh"
          :index="lightbox.index2"
          @close="lightbox.index2 = null"
          :effect="'fade'"
          v-if="$i18n.locale == 'zh'"
        >
        </CoolLightBox>
        <CoolLightBox
          :items="lightbox.secondRow"
          :index="lightbox.index2"
          @close="lightbox.index2 = null"
          :effect="'fade'"
          v-else
        >
        </CoolLightBox>
        <div class="order-1 order-lg-0 col-lg-6">
          <div class="main-theme mb-4" v-if="$i18n.locale == 'zh'">
            <h4>簡單直接的見證：先體驗　後分享</h4>
          </div>
          <div class="main-theme mb-4" v-else>
            <h4>Try-and-Tell: Simple But Direct</h4>
          </div>
          <div class="text-theme" v-if="$i18n.locale == 'zh'">
            「Hong Kong Super
            Fans」各有不同的專業和興趣，他們會獲邀參加不同主題的獨家活動，包括虛擬導覽、工作坊及實體活動，親身感受箇中的真實體驗，然後以「先體驗，後分享」的方式，與追隨者和好友真誠分享意見。旅發局更設立專屬的Facebook群組，定期將香港的最新旅遊體驗和活動介紹給一眾Hong
            Kong Super Fans，不斷培養他們對香港的喜愛，鼓勵他們與追隨者分享更多香港的趣聞。
          </div>
          <div class="text-theme" v-else>
            With various expertise and interests, the Hong Kong Super Fans are entitled to exclusive
            events of various themes. These events include virtual tours, workshops and physical
            events, so that they can immerse themselves in the authentic experience, and make
            genuine recommendations to their followers and friends in a “try-and-tell” mechanism.
            The regular updates on the latest tourism offerings and activities in Hong Kong via a
            dedicated Facebook group also keep fueling their passion for Hong Kong and inspiring
            these enthusiasts to share more happenings in Hong Kong with their followers.
          </div>
        </div>
        <div class="order-0 order-lg-1 mb-5 mb-lg-0 col-lg-6 ">
          <b-carousel id="carousel-2" class="carou-slide d-none d-md-block" controls>
            <b-carousel-slide>
              <template #img class="text-center">
                <b-aspect aspect="16:10" class="d-flex align-items-center">
                  <img
                    @click="lightbox.index2 = 0"
                    class="d-block img-fluid"
                    src="@/assets/initiatives/globalVisibility/superfans/4-2-4-2-0-preview-Super-Fans-e.jpg"
                    alt="image slot"
                  />
                </b-aspect>
              </template>
            </b-carousel-slide>
            <b-carousel-slide>
              <template #img class="text-center">
                <b-aspect aspect="16:10" class="d-flex align-items-center">
                  <img
                    @click="lightbox.index2 = 1"
                    class="d-block img-fluid"
                    src="@/assets/initiatives/globalVisibility/superfans/4-2-4-2-1-preview-KOL-corain-e.jpg"
                    alt="image slot"
                  />
                </b-aspect>
              </template>
            </b-carousel-slide>
            <b-carousel-slide>
              <template #img class="text-center">
                <b-aspect aspect="16:10" class="d-flex align-items-center">
                  <img
                    @click="lightbox.index2 = 2"
                    class="d-block img-fluid"
                    src="@/assets/initiatives/globalVisibility/superfans/4-2-4-2-2-preview-US_landlopers_IG-Story-e.jpg"
                    alt="image slot"
                  />
                </b-aspect>
              </template>
            </b-carousel-slide>
            <b-carousel-slide>
              <template #img class="text-center">
                <b-aspect aspect="16:10" class="d-flex align-items-center">
                  <img
                    @click="lightbox.index2 = 3"
                    class="d-block img-fluid"
                    src="@/assets/initiatives/globalVisibility/superfans/4-2-4-2-3-preview-Canada-Credit-goingawesomeplaces-e.jpg"
                    alt="image slot"
                  />
                </b-aspect>
              </template>
            </b-carousel-slide>
            <b-carousel-slide>
              <template #img class="text-center">
                <b-aspect aspect="16:10" class="d-flex align-items-center">
                  <img
                    @click="lightbox.index2 = 4"
                    class="d-block img-fluid"
                    src="@/assets/initiatives/globalVisibility/superfans/4-2-4-2-4-UK-preview-zannavandijk-e.jpg"
                    alt="image slot"
                  />
                </b-aspect>
              </template>
            </b-carousel-slide>
          </b-carousel>
          <b-carousel id="carousel-2" class="carou-slide d-block d-md-none" controls>
            <b-carousel-slide>
              <template #img class="text-center">
                <b-aspect aspect="3:4" class="d-flex align-items-center">
                  <img
                    @click="lightbox.index2 = 0"
                    class="d-block img-fluid"
                    src="@/assets/initiatives/globalVisibility/superfans/4-2-4-2-0-preview-Super-Fans-e.jpg"
                    alt="image slot"
                  />
                </b-aspect>
              </template>
            </b-carousel-slide>
            <b-carousel-slide>
              <template #img class="text-center">
                <b-aspect aspect="3:4" class="d-flex align-items-center">
                  <img
                    @click="lightbox.index2 = 1"
                    class="d-block img-fluid"
                    src="@/assets/initiatives/globalVisibility/superfans/4-2-4-2-1-preview-KOL-corain-e.jpg"
                    alt="image slot"
                  />
                </b-aspect>
              </template>
            </b-carousel-slide>
            <b-carousel-slide>
              <template #img class="text-center">
                <b-aspect aspect="3:4" class="d-flex align-items-center">
                  <img
                    @click="lightbox.index2 = 2"
                    class="d-block img-fluid"
                    src="@/assets/initiatives/globalVisibility/superfans/4-2-4-2-2-preview-US_landlopers_IG-Story-e.jpg"
                    alt="image slot"
                  />
                </b-aspect>
              </template>
            </b-carousel-slide>
            <b-carousel-slide>
              <template #img class="text-center">
                <b-aspect aspect="3:4" class="d-flex align-items-center">
                  <img
                    @click="lightbox.index2 = 3"
                    class="d-block img-fluid"
                    src="@/assets/initiatives/globalVisibility/superfans/4-2-4-2-3-preview-Canada-Credit-goingawesomeplaces-e.jpg"
                    alt="image slot"
                  />
                </b-aspect>
              </template>
            </b-carousel-slide>
            <b-carousel-slide>
              <template #img class="text-center">
                <b-aspect aspect="3:4" class="d-flex align-items-center">
                  <img
                    @click="lightbox.index2 = 4"
                    class="d-block img-fluid"
                    src="@/assets/initiatives/globalVisibility/superfans/4-2-4-2-4-UK-preview-zannavandijk-e.jpg"
                    alt="image slot"
                  />
                </b-aspect>
              </template>
            </b-carousel-slide>
          </b-carousel>
        </div>
      </div>

      <div class="row left-carou Televising mb-5">
        <CoolLightBox
          :items="lightbox.thirdRowZh"
          :index="lightbox.index3"
          @close="lightbox.index3 = null"
          :effect="'fade'"
          v-if="$i18n.locale == 'zh'"
        >
        </CoolLightBox>
        <CoolLightBox
          :items="lightbox.thirdRow"
          :index="lightbox.index3"
          @close="lightbox.index3 = null"
          :effect="'fade'"
          v-else
        >
        </CoolLightBox>
        <div class="col-lg-6 mb-5 mb-lg-0 align-self-start">
          <b-carousel id="carousel-3" class="carou-slide" controls>
            <b-carousel-slide>
              <template #img>
                <b-aspect aspect="16:10" class="d-flex align-items-center first-slide">
                  <img
                    @click="lightbox.index3 = 0"
                    class="d-block img-fluid"
                    src="@/assets/initiatives/globalVisibility/superfans/4-2-4-3-0-preview-LogoKV-e.jpg"
                    alt="image slot"
                  />
                </b-aspect>
              </template>
            </b-carousel-slide>
            <b-carousel-slide>
              <template #img>
                <b-aspect aspect="16:10" class="d-flex align-items-center second-slide">
                  <img
                    @click="lightbox.index3 = 1"
                    class="d-block img-fluid"
                    src="@/assets/initiatives/globalVisibility/superfans/4-2-4-3-1-preview-julian-e.jpg"
                    alt="image slot"
                  />
                </b-aspect>
              </template>
            </b-carousel-slide>
            <b-carousel-slide>
              <template #img>
                <b-aspect aspect="16:10" class="d-flex align-items-center second-slide">
                  <img
                    @click="lightbox.index3 = 2"
                    class="d-block img-fluid"
                    src="@/assets/initiatives/globalVisibility/superfans/4-2-4-3-2-preview-Christine-e.jpg"
                    alt="image slot"
                  />
                </b-aspect>
              </template>
            </b-carousel-slide>
            <b-carousel-slide>
              <template #img>
                <b-aspect aspect="16:10" class="d-flex align-items-center second-slide">
                  <img
                    @click="lightbox.index3 = 3"
                    class="d-block img-fluid"
                    src="@/assets/initiatives/globalVisibility/superfans/4-2-4-3-3-preview-ito-e.jpg"
                    alt="image slot"
                  />
                </b-aspect>
              </template>
            </b-carousel-slide>
            <b-carousel-slide>
              <template #img>
                <b-aspect aspect="16:10" class="d-flex align-items-center second-slide">
                  <img
                    @click="lightbox.index3 = 4"
                    class="d-block img-fluid"
                    src="@/assets/initiatives/globalVisibility/superfans/4-2-4-3-4-preview-satoru-e.jpg"
                    alt="image slot"
                  />
                </b-aspect>
              </template>
            </b-carousel-slide>
            <b-carousel-slide>
              <template #img>
                <b-aspect aspect="16:10" class="d-flex align-items-center second-slide">
                  <img
                    @click="lightbox.index3 = 5"
                    class="d-block img-fluid"
                    src="@/assets/initiatives/globalVisibility/superfans/4-2-4-3-5-preview-scott-e.jpg"
                    alt="image slot"
                  />
                </b-aspect>
              </template>
            </b-carousel-slide>
            <b-carousel-slide>
              <template #img>
                <b-aspect aspect="16:10" class="d-flex align-items-center second-slide">
                  <img
                    @click="lightbox.index3 = 6"
                    class="d-block img-fluid"
                    src="@/assets/initiatives/globalVisibility/superfans/4-2-4-3-6-preview-bhumika-e.jpg"
                    alt="image slot"
                  />
                </b-aspect>
              </template>
            </b-carousel-slide>
            <b-carousel-slide>
              <template #img>
                <b-aspect aspect="16:10" class="d-flex align-items-center second-slide">
                  <img
                    @click="lightbox.index3 = 7"
                    class="d-block img-fluid"
                    src="@/assets/initiatives/globalVisibility/superfans/4-2-4-3-7-preview-nikki-e.jpg"
                    alt="image slot"
                  />
                </b-aspect>
              </template>
            </b-carousel-slide>
            <b-carousel-slide>
              <template #img>
                <b-aspect aspect="16:10" class="d-flex align-items-center second-slide">
                  <img
                    @click="lightbox.index3 = 8"
                    class="d-block img-fluid"
                    src="@/assets/initiatives/globalVisibility/superfans/4-2-4-3-8-preview-billy-e.jpg"
                    alt="image slot"
                  />
                </b-aspect>
              </template>
            </b-carousel-slide>
            <b-carousel-slide>
              <template #img>
                <b-aspect aspect="16:10" class="d-flex align-items-center second-slide">
                  <img
                    @click="lightbox.index3 = 9"
                    class="d-block img-fluid"
                    src="@/assets/initiatives/globalVisibility/superfans/4-2-4-3-9-preview-Nokky-e.jpg"
                    alt="image slot"
                  />
                </b-aspect>
              </template>
            </b-carousel-slide>
            <!-- <b-carousel-slide>
              <template #img>
                <b-aspect aspect="16:10" class="d-flex align-items-center second-slide">
                  <img
                    @click="lightbox.index3 = 10"
                    class="d-block img-fluid w-100"
                    src="@/assets/initiatives/globalVisibility/superfans/4-2-4-3-10-preview-pehti-e.jpg"
                    alt="image slot"
                  />
                </b-aspect>
              </template>
            </b-carousel-slide> -->
          </b-carousel>
        </div>
        <div class="col-lg-6">
          <div class="main-theme mb-4" v-if="$i18n.locale == 'zh'">
            <h4>
              旅居人士的「香港情」
            </h4>
          </div>
          <div class="main-theme mb-4" v-else>
            <h4>
              Televising Renewed Love for Hong Kong
            </h4>
          </div>
          <div class="text-theme" v-if="$i18n.locale == 'zh'">
            2021年1月，《尋找家香味》在無綫電視翡翠台首播，分享他們對香港的鍾愛之情。節目跟隨10位外籍人士腳步，聆聽他們在香港的生活點滴，細說為何選擇來港追尋夢想，以及在香港尋找到原汁原味的家鄉美食。旅發局透過發起是次合作，藉居港外藉人士帶出香港作為國際都會，擁有吸引世界各地人才的核心優勢，足以引以為傲的訊息。
          </div>
          <div class="text-theme" v-else>
            The Hong Kong Super Fans will also be ambassadors of Hong Kong to share what they love
            about Hong Kong. In January 2021, <i>Taste of Home．Hong Kong</i> premiered on local
            broadcaster TVB Jade, featuring 10 expatriates. The expatriates told the stories about
            their life in Hong Kong, why they chose Hong Kong for chasing their dreams and where
            they could find authentic tastes of their homes here. It is a collaboration that HKTB
            has initiated to leverage local voices to bring out the core strengths of Hong Kong as
            an international city that attracts talents from different parts of the world and the
            beauty of the city that Hong Kong people are proud of.
          </div>
        </div>
      </div>
    </div>

    <div class="container-fluid foot-note mb-5">
      <div class="container py-3">
        <div class="row">
          <div class="col">
            <div class="title my-3" v-if="$i18n.locale == 'zh'">
              <h3>
                Hong Kong Super Fans：重點數字
              </h3>
            </div>
            <div class="title my-3" v-else>
              <h3>
                “Hong Kong Super Fans” in numbers
              </h3>
            </div>
            <div class="dot-points text-theme" v-if="$i18n.locale == 'zh'">
              <ul>
                <li>
                  Super Fans 人數：近400位
                </li>
                <li>
                  《尋找家香味》：共約430萬香港觀眾收看，環球宣傳效益達4,400萬港元
                </li>
              </ul>
            </div>
            <div class="dot-points text-theme" v-else>
              <ul>
                <li>
                  Number of Super Fans: About 400 fans and friends of Hong Kong
                </li>
                <li>
                  <i>Taste of Home．Hong Kong</i> media co-op: 4.3 million viewers in Hong Kong,
                  generated HK$44 million publicity value globally
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <GvPageSelector />
    </div>
    <GvNav mainTheme="main-theme" secondNav="second-nav" ssuper />

    <div class="container">
      <div class="row routing d-flex justify-content-between align-items-center my-5">
        <div class="col main-theme">
          <router-link :to="{ name: 'HolidayAtHome' }" class="d-flex flex-row align-items-center">
            <div class="">
              <img class="mr-2 route-arrow" src="@/assets/01/btn_catalog_arrow_l.svg" />
            </div>
            <div>{{ $t("title.holiday") }}</div>
          </router-link>
        </div>
        <div class="col main-theme">
          <router-link
            :to="{ name: 'GearingUpTheTrade-Uncease' }"
            class="d-flex justify-content-end text-right align-items-center"
          >
            {{ $t("title.gearing") }}
            <img class="ml-2 route-arrow" src="@/assets/01/btn_catalog_arrow_r.svg" />
          </router-link>
        </div>
      </div>
    </div>
    <BackToTopBtn />
  </div>
</template>

<script>
import BackToTopBtn from "@/components/BackToTopBtn.vue";
import CoolLightBox from "vue-cool-lightbox";
import "vue-cool-lightbox/dist/vue-cool-lightbox.min.css";
import InitNav from "@/components/InitiativesNav.vue";
import GvIntro from "@/components/GlobalVisibility/GvIntro.vue";
import GvNav from "@/components/GlobalVisibility/GvNav.vue";
import CustomBreadcrumb from "@/components/CustomBreadcrumb.vue";
import GvPageSelector from "@/components/GlobalVisibility/GvPageSelector.vue";

export default {
  name: "GlobalVisibility-Super",
  components: {
    BackToTopBtn,
    CoolLightBox,
    GvIntro,
    GvNav,
    InitNav,
    CustomBreadcrumb,
    GvPageSelector,
  },
  metaInfo: {
    title: "Global Visibility",
    titleTemplate: "%s - HKTB Annual Report 2020/21",
  },
  data() {
    return {
      lightbox: {
        firstRow: ["initiatives/global/superfans/4-2-4-1-SuperFans-KV-e.jpg"],
        secondRow: [
          {
            src:
              "https://players.brightcove.net/4875109325001/w9KYS3VVj_default/index.html?videoId=6286120390001",
            mediaType: "iframe",
          },
          "initiatives/global/superfans/4-2-4-2-1-KOL corain-e.jpg",
          "initiatives/global/superfans/4-2-4-2-2-US_landlopers_IG-Story-e.jpg",
          "initiatives/global/superfans/4-2-4-2-3-Canada_goingawesomeplaces-e.jpg",
          "initiatives/global/superfans/4-2-4-2-4-UK-zannavandijk-e.jpg",
        ],
        secondRowZh: [
          {
            src:
              "https://players.brightcove.net/4875109325001/w9KYS3VVj_default/index.html?videoId=6286120392001",
            mediaType: "iframe",
          },
          "initiatives/global/superfans/4-2-4-2-1-KOL corain-e.jpg",
          "initiatives/global/superfans/4-2-4-2-2-US_landlopers_IG-Story-e.jpg",
          "initiatives/global/superfans/4-2-4-2-3-Canada_goingawesomeplaces-e.jpg",
          "initiatives/global/superfans/4-2-4-2-4-UK-zannavandijk-e.jpg",
        ],
        thirdRow: [
          {
            src:
              "https://players.brightcove.net/4875109325001/w9KYS3VVj_default/index.html?videoId=6286121126001",
            mediaType: "iframe",
          },
          "initiatives/global/superfans/4-2-4-3-1-julian-e.jpg",
          "initiatives/global/superfans/4-2-4-3-2-Christine-e.jpg",
          "initiatives/global/superfans/4-2-4-3-3-ito-e.jpg",
          "initiatives/global/superfans/4-2-4-3-4-satoru-e.jpg",
          "initiatives/global/superfans/4-2-4-3-5-scott-e.jpg",
          "initiatives/global/superfans/4-2-4-3-6-bhumika-e.jpg",
          "initiatives/global/superfans/4-2-4-3-7-nikki-e.jpg",
          "initiatives/global/superfans/4-2-4-3-8-billy-e.jpg",
          "initiatives/global/superfans/4-2-4-3-9-Nokky-e.jpg",
        ],
        thirdRowZh: [
          {
            src:
              "https://players.brightcove.net/4875109325001/w9KYS3VVj_default/index.html?videoId=6286119586001",
            mediaType: "iframe",
          },
          "initiatives/global/superfans/4-2-4-3-1-julian-e.jpg",
          "initiatives/global/superfans/4-2-4-3-2-Christine-e.jpg",
          "initiatives/global/superfans/4-2-4-3-3-ito-e.jpg",
          "initiatives/global/superfans/4-2-4-3-4-satoru-e.jpg",
          "initiatives/global/superfans/4-2-4-3-5-scott-e.jpg",
          "initiatives/global/superfans/4-2-4-3-6-bhumika-e.jpg",
          "initiatives/global/superfans/4-2-4-3-7-nikki-e.jpg",
          "initiatives/global/superfans/4-2-4-3-8-billy-e.jpg",
          "initiatives/global/superfans/4-2-4-3-9-Nokky-e.jpg",
        ],
        index1: null,
        index2: null,
        index3: null,
      },
    };
  },
  mounted() {
    if (this.$i18n.locale == "zh") {
      let zh4 = document.querySelectorAll("h3, h4");
      for (let i = 0; i < zh4.length; i++) {
        zh4[i].style.fontWeight = "bold";
      }
    }
  },
};
</script>

<style lang="scss" scoped>
#carousel-2 {
  text-align: -webkit-center;
  img {
    max-height: 249px;
  }
}

@media (max-width: 1200px) {
  #carousel-2 {
    img {
      max-height: 198px;
    }
  }
}
@media (max-width: 991px) {
  #carousel-2 {
    img {
      max-height: none;
    }
  }
}
@media (max-width: 767px) {
  #carousel-2 {
    img {
      max-height: 300px;
    }
  }
}
@media (max-width: 575px) {
  #carousel-2 {
    img {
      max-height: 249px;
    }
  }
}
</style>
